import { cn } from "@lib/cn"
import type { ContactFormData } from "@site-types/send-mail"
import type { InputHTMLAttributes } from "react"
import type { FieldErrors, Path, RegisterOptions, UseFormRegister } from "react-hook-form"
import { FieldTooltip } from "../FieldTooltip"
import { extractErrorMessage } from "../field-utils"

type InputProps = {
  inputLabel: string
  toolTip: boolean
  inputProps: InputHTMLAttributes<HTMLInputElement> & { name: Path<ContactFormData> }
  errorMessage: string
  register?: UseFormRegister<ContactFormData>
  errors?: FieldErrors<ContactFormData>
  rules?: RegisterOptions<ContactFormData>
}

export const Input = ({
  inputLabel,
  toolTip,
  inputProps,
  errorMessage,
  register,
  errors,
  rules,
}: InputProps) => {
  const name = inputProps.name
  const id = inputProps.id || name
  const error = errors?.[name]
  const errorMsg = extractErrorMessage(errors, name, errorMessage)

  return (
    <div className="mb-8 flex flex-col">
      <label
        className="py-4"
        htmlFor={id}
      >
        {inputLabel}
      </label>

      <div className="relative inline-block w-full">
        <FieldTooltip
          message={errorMsg}
          open={!!error && toolTip}
        >
          <input
            {...inputProps}
            id={id}
            {...(register ? register(name, rules) : {})}
            className={cn("w-full", error && "outline-2 outline-[var(--pink)]", inputProps.className)}
          />
        </FieldTooltip>
      </div>
    </div>
  )
}
